<template>
  <div class="AtlasSummaryHeader">
    <template>
      <indicator-group
        :categories="drupalCategoryOptions"
        :links="drupalIndicatorOptions"
        @update:indicator="handleUpdateIndicator"
        standalone
      ></indicator-group>
    </template>
  </div>
</template>

<script>
import { useStore } from 'vuex';

import IndicatorGroup from './index.vue';

export default {
  name: 'atlas-indicator-group-standalone',

  emits: [],

  components: {
    IndicatorGroup,
  },

  props: {},

  methods: {},
  setup() {
    const store = useStore();

    const drupalCategoryOptions = window.Drupal?.settings?.indicatorCategories;

    const drupalIndicatorOptions = window.Drupal?.settings?.indicatorLinks;

    const handleUpdateIndicator = (value) => {
      if (value && value.href) window.location = value.href;
    };

    return {
      drupalCategoryOptions,
      drupalIndicatorOptions,
      handleUpdateIndicator,
    };
  },
};
</script>
